import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import NetworkTabs from "./NetworkTabs";

export default function NetworkHeaderRow({
  activeTab = "messages",
  onTabChange,
}) {
  return (
    <Stack
      direction={{ xs: "column", md: "row" }}
      alignItems={{ xs: "flex-start", md: "center" }}
      justifyContent="space-between"
      spacing={2}
      sx={{ mb: 2.2 }}
    >
      <Box>
        <Typography variant="h4" fontWeight={850} sx={{ letterSpacing: 0, color: "#102033", lineHeight: 1.05 }}>
          Activity
        </Typography>
        <Typography variant="body2" sx={{ mt: 0.45, color: "#718198", fontWeight: 500 }}>
          Reports, proof, responses, and messages from your TrustBuds.
        </Typography>
      </Box>

      <Stack direction="row" spacing={1.25} alignItems="center">
        <NetworkTabs value={activeTab} onChange={onTabChange} />
      </Stack>
    </Stack>
  );
}
